/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { VoucherPriceFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { VoucherPriceFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';
import type { getVoucherPriceDiscountPercent } from './getVoucherPriceDiscountPercent';

export const voucherPriceDataMock: VoucherPriceFragmentFragment = { value: 1337, currency: 'EUR' };

export const getVoucherPriceDiscountPercentReturnMock: ReturnType<
  typeof getVoucherPriceDiscountPercent
> = 13.37;

export function getVoucherPriceFragmentedData(data?: VoucherPriceFragmentFragment) {
  return makeFragmentData(data || voucherPriceDataMock, VoucherPriceFragmentFragmentDoc);
}
